import { Stack, Typography } from "@mui/material";
import React from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useTranslation } from "react-i18next";

export interface TableCellExpiresInProps {
  daysNumber: number;
}

const TableCellExpiresIn: React.FC<TableCellExpiresInProps> = ({ daysNumber }) => {
  const { t } = useTranslation();
  return (
    <Stack>
      {daysNumber < 3 && (
        <Stack direction="row" alignItems="center" spacing={0.5} color="warning.main">
          <ErrorOutlineIcon sx={{ top: "2px" }} />
          <Typography>{t("common:countDays", { count: daysNumber })}</Typography>
        </Stack>
      )}

      {daysNumber >= 3 && (
        <Typography color="text.secondary">{t("common:countDays", { count: daysNumber })}</Typography>
      )}
    </Stack>
  );
};

export default TableCellExpiresIn;
